/* eslint-disable quotes */
import { ComponentType, useState } from "react";
import SnackbarProvider from "react-simple-snackbar";
import SyntaxHighlighter from "react-syntax-highlighter";
import docco from "react-syntax-highlighter/dist/cjs/styles/hljs/docco";
import WASendmail from "./WASendCodeMail";
import { FormInputProps } from "@components/WAChatbutton/WAform/WidgetForm";

const CodeHighlighter = SyntaxHighlighter as unknown as ComponentType<{
    children?: React.ReactNode;
    customStyle?: React.CSSProperties;
    style?: unknown;
}>;

export interface WAWidgetSnippetProps {
    data: FormInputProps;
    onClose: () => void;
}

export const escapeHtml = (html: string): string => {
    if (!html) {
        return ""; // Return an empty string if input is undefined or null
    }
    return (
        html
            .replace(/\r?\n|\r/g, "\\n")
            // eslint-disable-next-line quotes
            .replace(/"/g, '\\"')
            .replace(/'/g, "\\'")
    );
};

const WhatsappWidgetSnippet: React.FC<WAWidgetSnippetProps> = (props) => {
    const { data, onClose } = props;
    const [clipboard, setclipboard] = useState("Copy to Clipboard");
    const codeCopy = () => {
        const copyText = document.querySelector("#code")?.textContent ?? "";
        navigator.clipboard.writeText(copyText);
        setclipboard("Copied !");
    };

    const backToForm: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        onClose();
    };
    const codeSnippet = function () {
        if (data.widgetStyle === "v1") {
            const messageText = `messageText: "${escapeHtml(data.question || "")}"`;
            const replyOptions = `replyOptions: [${(data.options || []).map((option) => `"${escapeHtml(option.content)}"`).join(", ") || `""`}]`;

            return `${messageText},
                ${replyOptions},`;
        }

        if (data.widgetStyle === "v2") {
            const customQuestion = `customQuestion: "${escapeHtml(data.customQuestion || "")}"`;
            const startChatBtnTxt = `startChatBtnTxt: "${escapeHtml(data.startChatBtnTxt || "")}"`;

            return `${customQuestion},
                ${startChatBtnTxt},`;
        }
    };
    const padLeft = (value: number) => {
        return String(value).padStart(2, "0");
    };
    const generateWidgetRandomCode = () => {
        const currentDate = new Date();

        const [date, month, year, hour] = [currentDate.getDate(), currentDate.getMonth() + 1, currentDate.getFullYear(), currentDate.getHours()];

        const widgetUrlCode = year + "-" + padLeft(month) + "-" + padLeft(date) + " " + padLeft(hour);

        return widgetUrlCode;
    };
    return (
        <div className="lg:w-3/5 w-full bg-white h-fit">
            <SnackbarProvider>
                <div>
                    <p className="flex justify-between items-center w-full text-base font-medium text-center bg-blue-50 px-4 py-2 rounded">
                        Copy and paste this code before the &lt;/Body&gt; tag on every page of your website.
                        <div
                            className="flex justify-end p-3.5"
                            onClick={() => {
                                onClose();
                            }}
                        >
                            <img className="w-4 h-4 cursor-pointer" src="/close.png" data-cy="close-modal" />
                        </div>
                    </p>
                </div>
                <div className="px-4 py-2">
                    <div className="lg:mx-4 px-4 py-4 rounded-2xl bg-gray-100">
                        <div className="flex items-center justify-end pb-2">
                            <button
                                aria-label="copy code"
                                className="font-medium text-sm focus:outline-none px-2 py-1 rounded-md hover:shadow-lg bg-blue-600 text-white"
                                onClick={codeCopy}
                            >
                                {clipboard}
                            </button>
                            <br />
                        </div>
                        <div className="font-light text-sm max-h-80 overflow-y-scroll">
                            {Boolean(data) && (
                                <pre id="code" className="px-6 py-4 mt-0">
                                    <CodeHighlighter customStyle={{ marginTop: "0" }} style={docco}>
                                        {`<script>
    (function (w, d, s, u) {
        w.gbwawc = {
            url: u,
            options: {
                waId: "${data.wanumber}",
                siteName: "${escapeHtml(data.brandName)}",
                siteTag: "${escapeHtml(data.statusTag)}",
                siteLogo: "${data.logo}",
                widgetPosition: "${data.buttonPosition}",
                welcomeMessage: "${escapeHtml(data.welcomeText)}",
                triggerMessage: "${escapeHtml(data.triggerMsg)}",
                brandColor: "#25D366",
                ${codeSnippet()}
                version: "${escapeHtml(data.widgetStyle)}",
                widgetPositionMarginX: "${data.widgetPositionMarginX}",
                widgetPositionMarginY: "${data.widgetPositionMarginY}",
            },
        };
        var h = d.getElementsByTagName(s)[0],
            j = d.createElement(s);
        j.async = true;
        j.src = u + "/whatsapp-widget.min.js?_=" + "${generateWidgetRandomCode()}";
        h.parentNode.insertBefore(j, h);
    })(window, document, "script", "https://waw.gallabox.com");
</script>`}
                                    </CodeHighlighter>
                                </pre>
                            )}
                        </div>
                        <div>
                            <p className="text-sm text-right pt-2 text-gray-700">
                                Still you want edit the widget{" "}
                                <a data-cy="click-here-link" className="text-blue-500 cursor-pointer hover:text-blue-600" href="/whatsapp-chat-button" onClick={backToForm}>
                                    Click here
                                </a>
                            </p>
                        </div>
                    </div>
                    <WASendmail data={data} />
                </div>
            </SnackbarProvider>
        </div>
    );
};
export default WhatsappWidgetSnippet;
